import { YhBox } from "@/erp_subpackage/components/YhBox"
import useGlobalModel from "@/erp_subpackage/model/globalModel"
import { importPropsConfig } from "@/erp_subpackage/utils/importFile"
import { MyContext } from "@/store/myContext"
import { Button, message, Modal, Spin, Upload } from "antd"
import React, { useContext } from "react"
import { useTranslation } from 'react-i18next'
import { useSupplierModel } from "../supplierModel"
import { DataTable } from "./DataTable"

export const DataBox = () => {
    const { t } = useTranslation();
    const { selectedRowKeys, searchParam, organType, exportSupplier, sync, downloadTpl, loadData, uploading, setUploading } = useSupplierModel()
    const { state, dispatch, detailsPage } = useContext(MyContext)
    const { user: { shopId, shopName, allowTransfer } } = useGlobalModel()

    //新增 查看 编辑
    const goPageNav = (mode) => {
        let tabName = {
            add: t(`base.view.DataBox.供应商新增`),
            edit: t(`base.view.DataBox.供应商编辑`),
            look: t(`base.view.DataBox.供应商查看`),
        }
        let modeKey = "baseSupplier/" + mode

        //动态传入要删除的nav key
        function handleDispatch(obj = {}) {
            dispatch({
                ...obj,
                type: "changeTabs",
                name: tabName[mode],
                activeMenu: modeKey,
                content: detailsPage.BaseSupplierDetails({
                    dispatch,
                    modeKey,
                    mode,
                    rowId: selectedRowKeys[0],
                }),
            })
        }

        if (mode === "edit") {
            const findNav = state.panes.find((item) => item.key === modeKey)
            if (findNav) {
                Modal.confirm({
                    title: `${t(`base.view.DataBox.温馨提醒`)}!`,
                    content: t(`base.view.DataBox.您还有供应商详情未保存，是否跳转`),
                    okText: t(`base.view.DataBox.跳转未保存页`),
                    cancelText: t(`base.view.DataBox.打开新页签`),
                    onOk: () => {
                        handleDispatch()
                    },
                    //打开新页签重新生成
                    onCancel: () => {
                        handleDispatch({ deleteKey: modeKey })
                    },
                })
                return
            }
            handleDispatch()
        } else if (mode === "add") {
            handleDispatch()
        } else if (mode === "look") {
            handleDispatch({ deleteKey: modeKey })
        }
    }

    const uploadCallback = (params) => {
        setUploading({ spinning: false })
        params && loadData()
    }
    const action = (
        <>
            <Button
                className="btn-item"
                shape="round"
                onClick={() => {
                    goPageNav("add")
                }}
                //各机构有调拨权限才可以新增
                hidden={!allowTransfer}
            >

                 {t(`base.view.DataBox.新增`)}
            </Button>
            <Button
                className="btn-item"
                shape="round"
                onClick={() => {
                    if (selectedRowKeys.length !== 1) {
                        message.warning(`${t(`base.view.DataBox.请选择单条数据进行编辑，点击鼠标右键可一键选中哦`)}!`)
                        return
                    }
                    goPageNav("edit")
                }}
                disabled={searchParam.shopId}
            >
                 {t(`base.view.DataBox.编辑`)}
            </Button>
            <Button
                className="btn-item"
                shape="round"
                onClick={() => {
                    if (selectedRowKeys.length !== 1) {
                        message.warning(`${t(`base.view.DataBox.请选择单条数据进行查看，点击鼠标右键可一键选中哦`)}!`)
                        return
                    }
                    goPageNav("look")
                }}
            >
                 {t(`base.view.DataBox.查看`)}
            </Button>
            <Upload showUploadList={false}  {...importPropsConfig(`/ci-storage/base/supplier/import`, uploadCallback, { shopId, shopName }, () => setUploading({ spinning: true, tip: `${t(`base.view.DataBox.加速上传中`)}...` }))}>
                <Button
                    className="btn-item"
                    type="link"
                    shape="round"
                    disabled={searchParam.shopId}
                    //各机构只有平台一个供应商，没有导入
                    hidden={!organType}
                > {t(`base.view.DataBox.导入`)}</Button>
            </Upload>
            <Button
                className="btn-item"
                shape="round"
                onClick={() => exportSupplier()}
            >
                 {t(`base.view.DataBox.导出`)}
            </Button>
            <Button
                className="btn-item"
                shape="round"
                onClick={() => downloadTpl()}
                disabled={searchParam.shopId}
                hidden={!organType}
            >
                 {t(`base.view.DataBox.下载模板`)}
            </Button>
        </>
    )
    return (
        <Spin {...uploading}>
            <YhBox title={t(`base.view.DataBox.供应商列表`)} action={action}>
                <DataTable />
            </YhBox>
        </Spin>
    )
}
